export const isNil = arg => arg === null || arg === undefined || arg === '';

// export function curry(func) {
//   return function curried(...args) {
//     if (args.length >= func.length) {
//       return func.apply(this, args);
//     }
//     return function (...args2) {
//       return curried.apply(this, args.concat(args2));
//     };
//   };
// }

export const isJsonFile = path => {
  return path?.includes('.json');
};

export const getQueryParams = () => {
  const queryString = window.location.search.toString().split('?')[1];
  const paramsList = queryString ? queryString.toString().split('&') : [];
  let params = {};
  paramsList.forEach(p => {
    const pValues = p.toString().split('=');
    params[pValues[0]] = decodeURIComponent(pValues[1]);
  });
  return params;
};

export const queryStringFromObject = (obj, withInitialParam) => {
  const pairs = Object.entries(obj);
  return pairs.reduce(
    (acc, [key, value], index) => {
      if (!isNil(key) && !isNil(value)) {
        return index ? `${acc}&${key}=${value}` : `${acc}${key}=${value}`;
      }
      return acc;
    },
    withInitialParam ? '&' : '?'
  );
};

export const debounce = (func, waitTime) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, waitTime);
  };
};

export const addIndexAsProperty = arr => {
  return arr.map((a, index) => {
    a.position = index + 1;
    return a;
  });
};

export const sortTilesByPriority = tiles => {
  // Separate tiles with and without priority
  const tilesWithPriority = tiles
    .map((tile, index) => ({ ...tile, originalIndex: index }))
    .filter(tile => tile.priority !== undefined)
    .sort((a, b) => a.priority - b.priority);

  const tilesWithoutPriority = tiles
    .map((tile, index) => ({ ...tile, originalIndex: index }))
    .filter(tile => tile.priority === undefined);

  // Merge sorted tiles with priority back into their original positions
  const sortedTiles = [];
  let priorityIndex = 0;
  let nonPriorityIndex = 0;

  for (let i = 0; i < tiles.length; i++) {
    if (tiles[i].priority !== undefined) {
      sortedTiles.push(tilesWithPriority[priorityIndex]);
      priorityIndex++;
    } else {
      sortedTiles.push(tilesWithoutPriority[nonPriorityIndex]);
      nonPriorityIndex++;
    }
  }

  return sortedTiles.map(({ originalIndex, ...rest }) => rest);
};
